// Loading
$(function() {
    $("#loading-wrapper").fadeOut(1000);
});

$(window).keydown(function(e) {
    if (e.which === 66 && event.ctrlKey) {
        $('body').toggleClass('hide-sidebar');
    }
})

$('.sidebar-tabs .nav-link[data-bs-toggle="tab"]').on('click', function (e) {
    $('body').removeClass('hide-sidebar');
});

$('.sidebar-tabs .nav').dblclick(function (e) {
    $('body').toggleClass('hide-sidebar');
})


// Toggle sidebar
$(".toggle-sidebar").on('click', function() {
    $(".page-wrapper").toggleClass("toggled");
});

$(function() {
    $('.sidebarMenuScroll').slimScroll({
        height: "calc(100vh - 50px)",
        color: '#d6dbe6',
        alwaysVisible: false,
        size: "5px",
        distance: '1px',
        railVisible: false,
        railColor: "#d6dbe6",
    });
});

// Custom Scroll Fixed Height 210px
$(function() {
    $('.customScroll').slimScroll({
        height: "210px",
        color: '#d6dbe6',
        alwaysVisible: false,
        size: "5px",
        distance: '1px',
        railVisible: false,
        railColor: "#d6dbe6",
    });
});

// Custom Scroll Fixed Height 300px
$(function() {
    $('.customScroll300').slimScroll({
        height: "300px",
        color: '#d6dbe6',
        alwaysVisible: false,
        size: "5px",
        distance: '1px',
        railVisible: false,
        railColor: "#d6dbe6",
    });
});

// Custom Scroll for Modal Dailog
$(function() {
    $('.modal-body.scrolling').slimScroll({
        height: "95%",
        color: '#d6dbe6',
        alwaysVisible: true,
        size: "5px",
        distance: '1px',
        railVisible: false,
        railColor: "#d6dbe6",
    });
});

// Custom Default/Compact/Pinned Sidebars JS
jQuery(function($) {

    // Default Compact menu
    $(".default-sidebar-dropdown > a").on('click', function() {
        $(".default-sidebar-submenu").slideUp(200);
        if ($(this).parent().hasClass("active")) {
            $(".default-sidebar-dropdown").removeClass("active");
            $(this).parent().removeClass("active");
        } else {
            $(".default-sidebar-dropdown").removeClass("active");
            $(this).next(".default-sidebar-submenu").slideDown(200);
            $(this).parent().addClass("active");
        }
    });


    // Compact menu
    $(".compact-sidebar-dropdown > a").on('click', function() {
        $(".compact-sidebar-submenu").slideUp(200);
        if ($(this).parent().hasClass("active")) {
            $(".compact-sidebar-dropdown").removeClass("active");
            $(this).parent().removeClass("active");
        } else {
            $(".compact-sidebar-dropdown").removeClass("active");
            $(this).next(".compact-sidebar-submenu").slideDown(200);
            $(this).parent().addClass("active");
        }
    });


    // Pinned sidebar
    $(function() {
        $(".slim-sidebar");
        $(".default-sidebar-wrapper").on('hover', function() {
                console.log("mouseenter");
                $(".slim-sidebar").addClass("sidebar-hovered");
            },
            function() {
                console.log("mouseout");
                $(".slim-sidebar").removeClass("sidebar-hovered");
            }
        )
    });


    // Added by Srinu 
    $(function() {
        // When the window is resized, 
        $(window).resize(function() {
            // When the width and height meet your specific requirements or lower
            if ($(window).width() <= 768) {
                $(".page-wrapper").removeClass("pinned");
            }
        });
        // When the window is resized, 
        $(window).resize(function() {
            // When the width and height meet your specific requirements or lower
            if ($(window).width() >= 768) {
                $(".page-wrapper").removeClass("toggled");
            }
        });
    });


});





/***********
***********
***********
	Bootstrap JS 
***********
***********
***********/

// Tooltip
var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
var tooltipList = tooltipTriggerList.map(function(tooltipTriggerEl) {
    return new bootstrap.Tooltip(tooltipTriggerEl)
})

// Popover
var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'))
var popoverList = popoverTriggerList.map(function(popoverTriggerEl) {
    return new bootstrap.Popover(popoverTriggerEl)
})

// Tabs on Hover
// jQuery('.sidebar-tabs .nav a.nav-link').hover(function(e){
// 	e.preventDefault();
// 	jQuery('.tab-pane').removeClass('active');
// 	tabContentSelector = jQuery(this).attr('href');
// 	jQuery(this).tab('show');
// 	jQuery(tabContentSelector).addClass('active');
// });

if ($("#alert-modal").length > 0) {
    ! function ($) {
        "use strict";
        var Alert = function() {
            this.element = $('#alert-modal');
            this.myModal = new bootstrap.Modal(this.element);
        };
        Alert.prototype.success = function (text) {
            this.element.find('#alert-body').attr('class', 'bg-success text-white');
            this.element.find('.modal-body h4').html('Well Done!');
            this.element.find('.modal-body i').attr('class', 'icon-check h1');
            this.element.find('.modal-body p').html(text);
            this.myModal.show();
        };
        Alert.prototype.error = function (text) {
            this.element.find('#alert-body').attr('class', 'bg-danger text-white');
            this.element.find('.modal-body h4').html('Oh snap!');
            this.element.find('.modal-body i').attr('class', 'icon-close h1');
            this.element.find('.modal-body p').html(text);
            this.myModal.show();
        };
        Alert.prototype.warning = function (text) {
            this.element.find('#alert-body').attr('class', 'bg-waring text-white');
            this.element.find('.modal-body h4').html('Incorrect Information');
            this.element.find('.modal-body i').attr('class', 'icon-alert-triangle h1');
            this.element.find('.modal-body p').html(text);
            this.myModal.show();
        };
        Alert.prototype.info = function (text) {
            this.element.find('#alert-body').attr('class', 'bg-info text-white');
            this.element.find('.modal-body h4').html('Heads up!');
            this.element.find('.modal-body i').attr('class', 'icon-info h1');
            this.element.find('.modal-body p').html(text);
            this.myModal.show();
        };

        $.alert = new Alert(), $.alert.constructor = Alert;
    }(window.jQuery);
}

! function ($) {
    "use strict";
    var Modal = function(ele, options={}) {
        if (ele instanceof $) {
            this.ele = ele;
        } else {
            this.ele = $(ele);
        }
        this.modal = new bootstrap.Modal(this.ele, options);

        // this.modal.option('backdrop', 'static')
        const $this = this;
        this.ele.on('click', '.modal-close', function (e) {
            e.preventDefault();
            $this.hide();
        });
    };
    Modal.prototype.customizeTitle = function (title) {
        this.ele.find('.modal-title').html(title);
        return this;
    };
    Modal.prototype.customizeBody = function (body) {
        this.ele.find('.modal-body').html(body);
        return this;
    };
    Modal.prototype.customizeFooter = function (footer) {
        this.ele.find('.modal-footer').html(footer);
        return this;
    };
    Modal.prototype.hideFooter = function (hide) {
        if (hide) {
            this.ele.find('.modal-footer').hide();
        } else {
            this.ele.find('.modal-footer').show();
        }
        return this;
    };

    Modal.prototype.setBackground = function (className) {
        $this.ele.find('.modal-header').attr('class', 'modal-header ' + className)
    };
    Modal.prototype.setSize = function (sizeClass) {
        this.ele.find('.modal-dialog').attr('class', 'modal-dialog ' + sizeClass);
    }

    Modal.prototype.show = function () {
        this.modal.show();
    }

    Modal.prototype.hide = function () {
        this.modal.hide();
    }

    $.customModal = function (ele, options={}) { return new Modal(ele, options); }, $.customModal.constructor = Modal;
}(window.jQuery);
